import { useTranslation } from '@fluxora/i18n';
import { Alert } from '@fluxora/ui';

/**
 * The switch right-of-rescission disclosure (E-SF06 AC3). Shown for SWITCHES only,
 * BEFORE the sign control — the customer must see it before they click-wrap.
 *
 * ── STATIC NOTICE, NO DATE MATH ────────────────────────────────────────────
 * This is the legal NOTICE of the 3-federal-business-day right to rescind without
 * penalty. It carries no computed date: the actual rescission DEADLINE is computed
 * SERVER-SIDE (real Texas business-day math, never `+3 days`) and returned in the
 * accept result — the browser renders that date after accept, it never derives it.
 */
export function RescissionDisclosure(): JSX.Element {
  const { t } = useTranslation();
  return (
    <Alert variant="info" title={t('shop.sign.rescission.title')} role="note">
      {t('shop.sign.rescission.body')}
    </Alert>
  );
}
